import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'
import { About } from 'screens/about'

const AboutPage: NextPageFC<Empty, PageLayoutOwnProps> = () => About()

AboutPage.layout = PageLayout

AboutPage.headProps = {
	title: pagesTitles[PagesPath.about].title,
	description:
		'Узнайте больше о цифровой платформе Credit.Club: свидетельства и уставные документы, отзывы клиентов. Работаем под надзором Банка России.',
	ogTitle: 'О компании Credit.Club',
	ogImageName: 'main.jpg',
	ogDescription:
		'Узнайте больше о цифровой платформе Credit.Club: свидетельства и уставные документы, отзывы клиентов. Работаем под надзором Банка России.',
}
AboutPage.breadcrumb = { title: 'О компании' }

export default AboutPage
